import {
  Box,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
} from '@mui/material';
import { ThemePalette } from 'mui.theme';
import TerrainFourWheels from 'views/DriverBehavior/Inclinometer/Schematics/FourWheels';
import TerrainSixWheels from 'views/DriverBehavior/Inclinometer/Schematics/SixWheels';
import ThreeAxlesSixWheels from 'views/DriverBehavior/Inclinometer/Schematics/ThreeAxlesSixWheels';
import ThreeAxlesTenWheels from 'views/DriverBehavior/Inclinometer/Schematics/ThreeAxlesTenWheels';
import FourSixWheels from 'views/DriverBehavior/Inclinometer/Schematics/FourSixWheels';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const TirePatternSelector = ({
  enableDarkTheme,
  value,
  setValue,
}: {
  enableDarkTheme: boolean;
  value: string;
  setValue: (arg: string) => void;
}) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const radioSx = {
    color: enableDarkTheme ? palette.primary : ThemePalette.typography.primary,
    '&.Mui-checked': {
      color: enableDarkTheme
        ? palette.primary
        : ThemePalette.typography.primary,
    },
  };

  return (
    <FormControl>
      <RadioGroup
        row
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
        }}
      >
        <FormControlLabel
          value="4x4"
          control={<Radio sx={radioSx} />}
          label={
            <Box
              sx={{
                border: '1px solid #4299e1',
                padding: '20px',
                borderRadius: '4px',
              }}
            >
              <TerrainFourWheels
                values={{
                  p1: 32.5,
                  p2: 31.8,
                  p3: 33.2,
                  p4: 32.1,
                }}
                width={60}
                height={90}
              />
            </Box>
          }
        />
        <FormControlLabel
          value="6x4"
          control={<Radio sx={radioSx} />}
          label={
            <Box
              sx={{
                border: '1px solid #4299e1',
                padding: '20px',
                borderRadius: '4px',
              }}
            >
              <TerrainSixWheels
                values={{
                  p1: 32.5,
                  p2: 31.8,
                  p3: 33.2,
                  p4: 32.1,
                  p5: 33.0,
                  p6: 31.9,
                }}
                width={60}
                height={90}
              />
            </Box>
          }
        />
        <FormControlLabel
          value="6x6"
          control={<Radio sx={radioSx} />}
          label={
            <Box
              sx={{
                border: '1px solid #4299e1',
                padding: '20px',
                borderRadius: '4px',
              }}
            >
              <ThreeAxlesSixWheels
                values={{
                  p1: 32.5,
                  p2: 31.8,
                  p3: 33.2,
                  p4: 32.1,
                  p5: 33.0,
                  p6: 31.9,
                }}
                width={60}
                height={90}
              />
            </Box>
          }
        />
        <FormControlLabel
          value="10x6"
          control={<Radio sx={radioSx} />}
          label={
            <Box
              sx={{
                border: '1px solid #4299e1',
                padding: '20px',
                borderRadius: '4px',
              }}
            >
              <ThreeAxlesTenWheels
                values={{
                  p1: 32.5,
                  p2: 31.8,
                  p3: 33.2,
                  p4: 32.1,
                  p5: 33.0,
                  p6: 31.9,
                  p7: 32.7,
                  p8: 32.0,
                  p9: 32.4,
                  p10: 31.7,
                }}
                width={48}
                height={120}
              />
            </Box>
          }
        />
        <FormControlLabel
          value="4x6"
          control={<Radio sx={radioSx} />}
          label={
            <Box
              sx={{
                border: '1px solid #4299e1',
                padding: '20px',
                borderRadius: '4px',
              }}
            >
              <FourSixWheels
                values={{
                  p1: 32.5,
                  p2: 31.8,
                  p3: 33.2,
                  p4: 32.1,
                  p5: 33.0,
                  p6: 31.9,
                }}
                width={60}
                height={90}
              />
            </Box>
          }
        />
      </RadioGroup>
    </FormControl>
  );
};
